<template>
  <MainLayout :initialDrawerExpanded="false" contentClass="pa-0" :has-sidebar="false">
    <template #header>
      <div class="overline">
        <PageBack />
      </div>
    </template>

    <template #content>
      <SupportHero v-if="!admin" compact title="Tickets" icon="mdi-ticket-outline" />
      <div class="pa-4">
      <v-row class="pa-2">
        <v-col cols="12" class="d-flex align-center">
          <h2>{{ admin ? 'Tickets — administration' : 'Tickets' }}</h2>
          <v-spacer />
          <v-btn v-if="!admin" color="primary" elevation="0" @click="showNew = true">
            <v-icon left>mdi-plus</v-icon>Nouveau ticket
          </v-btn>
        </v-col>

        <v-col cols="12">
          <v-tabs v-if="tabs.length > 1" v-model="tab" @change="load(1)">
            <v-tab v-for="t in tabs" :key="t.label">{{ t.label }}</v-tab>
          </v-tabs>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field v-model="q" label="Rechercher" prepend-inner-icon="mdi-magnify"
            outlined dense hide-details clearable @input="debouncedLoad" />
        </v-col>
        <v-col cols="12" md="3">
          <v-select v-model="status" :items="statusItems" label="Statut"
            outlined dense hide-details clearable @change="load(1)" />
        </v-col>

        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="tickets"
            :loading="loading"
            :server-items-length="count"
            :page="page"
            :items-per-page="25"
            :footer-props="{ 'items-per-page-options': [25] }"
            no-data-text="Aucun ticket"
            @update:page="load"
            @click:row="open"
            style="cursor: pointer"
          >
            <template #[`item.status`]="{ item }">
              <v-chip small :color="statusColor(item.status)" dark>{{ statusLabel(item.status) }}</v-chip>
            </template>
            <template #[`item.priority`]="{ item }">
              <v-icon v-if="item.priority === 'high'" color="error" small>mdi-arrow-up-bold</v-icon>
              <v-icon v-else-if="item.priority === 'low'" small>mdi-arrow-down</v-icon>
            </template>
            <template #[`item.author`]="{ item }">{{ item.author.username }}</template>
            <template #[`item.updated_at`]="{ item }">{{ formatDate(item.updated_at) }}</template>
          </v-data-table>
        </v-col>
      </v-row>
      <SupportNewDialog v-model="showNew" />
      </div>
    </template>
  </MainLayout>
</template>

<script>
import PageBack from '@/components/ui/PageBack.vue'
import MainLayout from '@/layout/MainLayout.vue'
import SupportHero from '@/components/support/SupportHero.vue'
import SupportNewDialog from '@/components/support/SupportNewDialog.vue'
import { fetchTickets } from '@/services/supportApi'
import { STATUS_ITEMS, statusColor, statusLabel, formatDate } from '@/utils/support'

export default {
  name: 'SupportListView',
  components: { PageBack, SupportHero, MainLayout, SupportNewDialog },
  props: {
    openNew: { type: Boolean, default: false },
    /** Staff triage mode (/admin/tickets): all tickets, unassigned tab. Off in the support space. */
    admin: { type: Boolean, default: false },
  },
  data() {
    return {
      tab: 0,
      q: '',
      status: null,
      tickets: [],
      count: 0,
      page: 1,
      loading: false,
      showNew: this.openNew,
      statusItems: STATUS_ITEMS,
      timer: null,
      headers: [
        { text: 'Référence', value: 'reference', sortable: false },
        { text: 'Sujet', value: 'subject', sortable: false },
        { text: 'Statut', value: 'status', sortable: false },
        { text: 'Priorité', value: 'priority', sortable: false },
        { text: 'Auteur', value: 'author', sortable: false },
        { text: 'Mis à jour', value: 'updated_at', sortable: false },
      ],
    }
  },
  computed: {
    isStaff() {
      return this.$store.getters['settings/isStaff']
    },
    /** Tabs and the API params they map to. Staff see only their own tickets in the support space. */
    tabs() {
      if (this.admin) return [{ label: 'Tous', params: {} }, { label: 'Non assignés', params: { unassigned: 1 } }]
      if (this.isStaff) return [{ label: 'Mes tickets', params: { mine: 1 } }]
      return [{ label: 'Tous', params: {} }, { label: 'Mes tickets', params: { mine: 1 } }]
    },
  },
  created() {
    this.load(1)
  },
  methods: {
    statusColor,
    statusLabel,
    formatDate,
    debouncedLoad() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.load(1), 300)
    },
    async load(page = 1) {
      this.loading = true
      this.page = page
      const params = { page, q: this.q, status: this.status, ...this.tabs[this.tab].params }
      try {
        const data = await fetchTickets(params)
        this.tickets = data.results
        this.count = data.count
      } catch (e) {
        this.tickets = []
      } finally {
        this.loading = false
      }
    },
    open(ticket) {
      this.$router.push({ name: this.admin ? 'admin_ticket_detail' : 'ticket_detail', params: { id: ticket.id } })
    },
  },
}
</script>
